
// // // import React, { useRef, useEffect, useState } from "react";

// // // function CustomVedio({lessonData}) {
// // //   console.log(lessonData?.video,"lessonData");
  
// // //     const videoRef = useRef(null);
// // //   const [currentTime, setCurrentTime] = useState(0);
//   // const [stopAtTime, setStopAtTime] = useState(148); // توقف أول عند 2:28 = 148 ثانية
// // //   const [answered, setAnswered] = useState(false); // هل تم الإجابة الصحيحة؟
// // //     const [progress, setProgress] = useState(0);

// // //   const jumpToTime = 159;
// // //   useEffect(() => {
// // //     const interval = setInterval(() => {
// // //       if (videoRef.current) {
// // //         setCurrentTime(videoRef?.current?.currentTime);
// // //       }
// // //     }, 200);
// // //     return () => clearInterval(interval);
// // //   }, []);

// // //   const handleTimeUpdate = () => {
// // //     if (videoRef?.current?.currentTime >= stopAtTime) {
// // //       videoRef.current.pause();
// // //     }
// // //   };


// //   function goFullscreen() {
// //   const container = document.getElementById("videoContainer");
// //   if (container.requestFullscreen) {
// //     container.requestFullscreen();
// //   }
// // }
// // //   // التعامل مع الضغط على أي مكان في شريط التقدم
// // //   const handleSeek = (e) => {
// // //     const video = videoRef.current;
// // //     const rect = e.currentTarget.getBoundingClientRect();
// // //     const clickX = e.clientX - rect.left; // المسافة من بداية الشريط
// // //     const newTime = (clickX / rect.width) * video.duration;
// // //     video.currentTime = newTime;
// // //     setProgress((newTime / video.duration) * 100); // تحديث الشريط مباشرة
// // //   };
// // //   useEffect(() => {
// // //     const video = videoRef.current;
// // //     if (!video) return;

// // //     const handleTimeUpdate = () => {
// // //       setProgress((video.currentTime / video.duration) * 100);
// // //     };

// // //     video.addEventListener("timeupdate", handleTimeUpdate);
// // //     return () => {
// // //       video.removeEventListener("timeupdate", handleTimeUpdate);
// // //     };
// // //   }, []);


// // //   return (
// // // <div
// // //   id="videoContainer"
// // //   style={{ position: "relative", width: "100%" }}
// // // >
// // //   {/* <button onClick={goFullscreen}>Full Screen</button> */}

// // //   <video
// // //     ref={videoRef}
// // //     src={lessonData.video}
// // //     autoPlay
// // //       // controlsList="nofullscreen"
// // //   playsInline
// // //   webkit-playsinline="true"

// // //     // controls
// // //     onTimeUpdate={handleTimeUpdate}
// // //     width="100%"
// // //   />

// // //       <div
// // //         onClick={handleSeek}
// // //         style={{
// // //           marginTop: "10px",
// // //           width: "100%",
// // //           height: "10px",
// // //           backgroundColor: "#ccc",
// // //           borderRadius: "5px",
// // //           cursor: "pointer",
// // //           position: "absolute",
// // //           bottom:0
// // //         }}
// // //       >
// // //         <div
// // //           style={{
// // //             width: `${progress}%`,
// // //             height: "100%",
// // //             backgroundColor: "#FF7622",
// // //             borderRadius: "5px",
// // //             position: "absolute",
// // //             top: 0,
// // //             left: 0,
// // //           }}
// // //         />
// // //       </div>

// // // </div>


// // //       )
// // // }

// // // export default CustomVedio

// // import React, { useRef, useState, useEffect } from "react";

// // function CustomVedio({ lessonData }) {
// //   const videoRef = useRef(null);
// //   const [isPlaying, setIsPlaying] = useState(true);
// //   const [progress, setProgress] = useState(0);

// //   useEffect(() => {
// //     const video = videoRef.current;
// //     if (!video) return;

// //     const handleTimeUpdate = () => {
// //       setProgress((video.currentTime / video.duration) * 100);
// //     };

// //     const handleEnded = () => {
// //       setProgress(100);
// //       setIsPlaying(false);
// //     };

// //     video.addEventListener("timeupdate", handleTimeUpdate);
// //     video.addEventListener("ended", handleEnded);

// //     return () => {
// //       video.removeEventListener("timeupdate", handleTimeUpdate);
// //       video.removeEventListener("ended", handleEnded);
// //     };
// //   }, []);

// //   const togglePlay = () => {
// //     const video = videoRef.current;
// //     if (!video) return;

// //     if (isPlaying) {
// //       video.pause();
// //       setIsPlaying(false);
// //     } else {
// //       video.play();
// //       setIsPlaying(true);
// //     }
// //   };

// //   // دالة لحساب الوقت من النقرة أو اللمس
// //   const handleSeek = (e) => {
// //     const video = videoRef.current;
// //     if (!video) return;

// //     let clientX;

// //     // إذا كان touch event
// //     if (e.touches && e.touches.length > 0) {
// //       clientX = e.touches[0].clientX;
// //     } else {
// //       clientX = e.clientX;
// //     }

// //     const rect = e.currentTarget.getBoundingClientRect();
// //     const clickX = rect.right - clientX; // للـ RTL (من اليمين)
// //     const newTime = (clickX / rect.width) * video.duration;

// //     video.currentTime = newTime;
// //     setProgress((newTime / video.duration) * 100);
// //   };

// //   return (
// //     <div style={{ width: "640px", margin: "20px auto", position: "relative" }}>
// //       <video
// //         ref={videoRef}
// //         src={lessonData.video}
// //         style={{ width: "100%", height: "50vh", backgroundColor: "black" }}
// //         playsInline
// //         webkit-playsinline="true"
// //         autoPlay
// //         controls
// //       />



// //       {/* شريط التقدم RTL */}
// //       <div
// //         onClick={handleSeek}
// //         onTouchStart={handleSeek}
// //         style={{
// //           position: "absolute",
// //           bottom: "10px",
// //           right: "5%",
// //           width: "90%",
// //           height: "8px",
// //           backgroundColor: "#ccc",
// //           borderRadius: "4px",
// //           cursor: "pointer",
// //           zIndex: 10,
// //         }}
// //       >
// //         <div
// //           style={{
// //             width: `${progress}%`,
// //             height: "100%",
// //             backgroundColor: "#FF7622",
// //             borderRadius: "4px",
// //             position: "absolute",
// //             top: 0,
// //             right: 0,
// //           }}
// //         />
// //       </div>
// //     </div>
// //   );
// // }

// // export default CustomVedio




// // import React, { useRef, useState, useEffect } from "react";

// // function CustomVedio({ lessonData }) {
// //   const videoRef = useRef(null);
// //   const [isPlaying, setIsPlaying] = useState(true);
// //   const [progress, setProgress] = useState(0);

// //   useEffect(() => {
// //     const video = videoRef.current;
// //     if (!video) return;

// //     const handleTimeUpdate = () => {
// //       setProgress((video.currentTime / video.duration) * 100);
// //     };

// //     const handleEnded = () => {
// //       setProgress(100);
// //       setIsPlaying(false);
// //     };

// //     video.addEventListener("timeupdate", handleTimeUpdate);
// //     video.addEventListener("ended", handleEnded);

// //     return () => {
// //       video.removeEventListener("timeupdate", handleTimeUpdate);
// //       video.removeEventListener("ended", handleEnded);
// //     };
// //   }, []);

// //   const togglePlay = () => {
// //     const video = videoRef.current;
// //     if (!video) return;

// //     if (isPlaying) {
// //       video.pause();
// //       setIsPlaying(false);
// //     } else {
// //       video.play();
// //       setIsPlaying(true);
// //     }
// //   };

// //   // دالة لحساب الوقت من النقرة أو اللمس
// //   const handleSeek = (e) => {
// //     const video = videoRef.current;
// //     if (!video) return;

// //     let clientX;

// //     // إذا كان touch event
// //     if (e.touches && e.touches.length > 0) {
// //       clientX = e.touches[0].clientX;
// //     } else {
// //       clientX = e.clientX;
// //     }

// //     const rect = e.currentTarget.getBoundingClientRect();
// //     const clickX = rect.right - clientX; // للـ RTL (من اليمين)
// //     const newTime = (clickX / rect.width) * video.duration;

// //     video.currentTime = newTime;
// //     setProgress((newTime / video.duration) * 100);
// //   };

// //   return (
// //     <div style={{ width: "640px", margin: "20px auto", position: "relative" }}>
// //       <video
// //         ref={videoRef}
// //         src={lessonData.video}
// //         style={{ width: "100%", height: "50vh", backgroundColor: "black" }}
// //         playsInline
// //         webkit-playsinline="true"
// //         autoPlay
// //         controls
// //       />



// //       {/* شريط التقدم RTL */}
// //       <div
// //         onClick={handleSeek}
// //         onTouchStart={handleSeek}
// //         style={{
// //           position: "absolute",
// //           bottom: "10px",
// //           right: "5%",
// //           width: "90%",
// //           height: "8px",
// //           backgroundColor: "#ccc",
// //           borderRadius: "4px",
// //           cursor: "pointer",
// //           zIndex: 10,
// //         }}
// //       >
// //         <div
// //           style={{
// //             width: `${progress}%`,
// //             height: "100%",
// //             backgroundColor: "#FF7622",
// //             borderRadius: "4px",
// //             position: "absolute",
// //             top: 0,
// //             right: 0,
// //           }}
// //         />
// //       </div>
// //     </div>
// //   );
// // }

// // export default CustomVedio


// import React, { useRef, useState, useEffect } from "react";
// import "./CustomVedio.css"
// function CustomVedio({ lessonData }) {
// const videoRef = useRef(null);
// const [isPlaying, setIsPlaying] = useState(true);
// const [progress, setProgress] = useState(0);
// const [answered, setAnswered] = useState(0);
//   const [stopAtTime, setStopAtTime] = useState(lessonData.stopAtTime); // توقف أول عند 2:28 = 148 ثانية
//     const [videoEnded, setVideoEnded] = useState(false);
//     const [currentQuestion, setCurrentQuestion] = useState(null);
//     const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0); // 🚀 تتبع الفهرس

// // const jumpToTime = 159;
// const jumpToTime = lessonData.jumpToTime;
// useEffect(() => {
// const video = videoRef.current;
// if (!video) return;

// const handleTimeUpdate = () => {
//   setProgress((video.currentTime / video.duration) * 100);

//   // توقف الفيديو عند الثانية المحددة فقط أثناء التشغيل الطبيعي
//   // if (video.currentTime >= stopAtTime && isPlaying) {
//   //   video.pause();
//   //   setIsPlaying(false);
//   // }
// };

// const handleEnded = () => {
//   setProgress(100);
//   setIsPlaying(false);
// };

// video.addEventListener("timeupdate", handleTimeUpdate);
// video.addEventListener("ended", handleEnded);

// return () => {
//   video.removeEventListener("timeupdate", handleTimeUpdate);
//   video.removeEventListener("ended", handleEnded);
// };

// }, [isPlaying]);

// const togglePlay = () => {
// const video = videoRef.current;
// if (!video) return;

// // إذا الفيديو تجاوز نقطة التوقف، أعد ضبطه على stopAtTime قبل التشغيل
// if (video.currentTime >= stopAtTime) {
//   video.currentTime = stopAtTime;
// }

// if (isPlaying) {
//   video.pause();
//   setIsPlaying(false);
// } else {
//   video.play();
//   setIsPlaying(true);
// }

// };

// const handleSeek = (e) => {
// const video = videoRef.current;
// if (!video) return;

// let clientX;
// if (e.touches && e.touches.length > 0) {
//   clientX = e.touches[0].clientX;
// } else {
//   clientX = e.clientX;
// }

// const rect = e.currentTarget.getBoundingClientRect();
// const clickX = rect.right - clientX; // RTL
// const newTime = (clickX / rect.width) * video.duration;

// // ضع الفيديو على الوقت الجديد مباشرة
// video.currentTime = newTime;
// setProgress((newTime / video.duration) * 100);

// };
// const handleVideoClick = (event) => {
//     // 🛑 الأهم: منع سلوك المتصفح الافتراضي (مثل تشغيل/إيقاف الفيديو)
//     event.preventDefault(); 
//     event.stopPropagation(); 
    
//     const video = videoRef.current;
//     const rect = video.getBoundingClientRect();

//     let clientX, clientY;

//     // 1. استخراج الإحداثيات بناءً على نوع الحدث (Mouse vs Touch)
//     if (event.touches && event.touches.length > 0) {
//         // حدث لمس (لـ onTouchStart)
//         clientX = event.touches[0].clientX;
//         clientY = event.touches[0].clientY;
//     } else if (event.changedTouches && event.changedTouches.length > 0) {
//         // حدث لمس بعد التغيير (لـ onTouchEnd)
//         clientX = event.changedTouches[0].clientX;
//         clientY = event.changedTouches[0].clientY;
//     } else {
//         // حدث نقر (لـ onClick)
//         clientX = event.clientX;
//         clientY = event.clientY;
//     }

//     // 2. حساب الإحداثيات النسبية (X و Y)
//     const x = clientX - rect.left;
//     const y = clientY - rect.top;

//     const xPercent = (x / rect.width) * 100;
//     const yPercent = (y / rect.height) * 100;
    
//     // ... باقي منطق التحقق من الإجابة (بدون تغيير) ...

//     // التحقق من الإجابة الأولى فقط إذا لم تُجب بعد
//     if (video.currentTime >= stopAtTime && !answered) {
//           if (video.currentTime >= stopAtTime) {

//         if (xPercent <= lessonData?.xPercent && yPercent >= lessonData?.yPercent1 && yPercent <= lessonData?.yPercent2) {
//             alert("✅ إجابة صحيحة!");
//             video.currentTime = jumpToTime;
//             video.play();
//             setAnswered(true);
//             setStopAtTime(153);
//         } else {
//             alert("❌ إجابة خاطئة. يرجى المحاولة مرة أخرى.");
//         }
//       }
//         return;
//     }

//     // التحقق من الإجابة الثانية بعد الثانية المحددة
//     if (video.currentTime >= jumpToTime) {
//         if (xPercent <= lessonData?.xPercent2 && yPercent >= lessonData?.yPercent3 && yPercent <= lessonData?.yPercent4) {
//             alert("✅ إجابة صحيحة!");
//         } else {
//             alert("❌ إجابة خاطئة. يرجى المحاولة مرة أخرى.");
//         }
//         return;
//     }
// };

//     const handleVideoEnd = () => {
//         setIsPlaying(false);
//         setVideoEnded(true);
//         if (lessonData.questions.length > 0) {
//             // ابدأ بالسؤال الأول (الفهرس 0)
//             setCurrentQuestion(lessonData.questions[0]); 
//             setCurrentQuestionIndex(0);
//         }
//     };

//     // 🚀 منطق الإجابة والانتقال إلى السؤال التالي
//     const handleAnswer = (option) => {
//         if (option === currentQuestion.answer) {
//             alert("✅ إجابة صحيحة!");
            
//             const nextIndex = currentQuestionIndex + 1;
            
//             if (nextIndex < lessonData.questions.length) {
//                 // الانتقال إلى السؤال التالي
//                 setCurrentQuestion(lessonData.questions[nextIndex]);
//                 setCurrentQuestionIndex(nextIndex);
//             } else {
//                 // انتهت جميع الأسئلة
//                 alert("🥳 تهانينا! لقد أكملت جميع أسئلة المراجعة بنجاح.");
//                 setCurrentQuestion(null);
//             }
//         } else {
//             alert("❌ إجابة خاطئة. يرجى المحاولة مرة أخرى.");
//             // يظل السؤال الحالي معروضًا حتى يجيب بشكل صحيح
//         }
//     };
// return (
// <div style={{   position: "relative" }}>
// <video
// ref={videoRef}
// src={lessonData.video}
// style={{ width: "100%",height: "50vh", backgroundColor: "black" }}
// playsInline
// webkit-playsinline="true"
// autoPlay
// onEnded={handleVideoEnd}
// className="video__container"
// // onClick={handleVideoClick}
// // onTouchEnd={handleVideoClick}
// />
//           {currentQuestion && videoEnded && (
//                 <div
//                     style={{ position: 'absolute', left: "25%", bottom:"10%",width: '50%', height: '84%', backgroundColor: 'rgba(236,236,236,1)', color: 'white', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', zIndex: 12, padding: '20px',borderRadius:"22px" ,boxShadow:"0px 4px 12px rgba(0,0,0,0.2)"}}
//                     className='question_container'
//                 >
//                     <h4 style={{color:"rgba(118,125,129,1)",textAlign:"right",fontSize:"15px"}}>السؤال رقم {currentQuestionIndex + 1}: {currentQuestion.question}</h4>
//                     {currentQuestion.options.map((opt, i) => (
//                         <button
//                             key={i}
//                             onClick={() => handleAnswer(opt)}
//                             style={{ display: 'block', width: '80%',fontSize:"12px", margin: '10px 0', color: 'black', border: 'none', padding: '10px 15px', borderRadius: '5px', cursor: 'pointer' }}
//                             className='option_container'
//                         >
//                         {opt}
//                         </button>
//                     ))}
//                 </div>
//             )}
//   <div
//     onClick={handleSeek}
//     onTouchStart={handleSeek}
//     style={{
//       position: "absolute",
//       bottom: "10px",
//       right: "5%",
//       width: "90%",
//       height: "8px",
//       backgroundColor: "#ccc",
//       borderRadius: "4px",
//       cursor: "pointer",
//       zIndex: 10,
//     }}
//   >
//     <div
//       style={{
//         width: `${progress}%`,
//         height: "100%",
//         backgroundColor: "#FF7622",
//         borderRadius: "4px",
//         position: "absolute",
//         top: 0,
//         right: 0,
//       }}
//     />
//   </div>
// </div>

// );
// }

// export default CustomVedio;
/********************************************************************************************** */
// import axios from 'axios';
// import React, { useEffect, useRef, useState } from 'react'
// import ReactPlayer from 'react-player';
// import { apiUrl } from '../../constant/apiUrl';
// import { useSelector } from 'react-redux';

// function CustomVedio({questions,videoPath}) {
//   const videoRef = useRef(null);
// const [correctCount, setCorrectCount] = useState(0);
// const [wrongCount, setWrongCount] = useState(0);
// console.log(questions);
//   const { auth } = useSelector((state) => state);
//   const token = auth.access_token; // Assuming token is stored in auth slice

//   const playerRef = useRef(null);
//   const [videoEnded, setVideoEnded] = useState(false);
//   const [currentQuestion, setCurrentQuestion] = useState(null);
//   const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0); // 🚀 تتبع الفهرس
//   const [answered, setAnswered] = useState(false);
//   const [isPlaying, setIsPlaying] = useState(false);

//   // const questions = [
//   //   { time: 5, question: ".اذكرْ سببَ كَثرةِ البواخرِ في مياهِ طوكيو حَسبَ رأي الكاتبِ", options: ["لأن اليابان تمتلك أكبر أسطول صيد في العالم", "لأن اليابان تستورد الخامات وتصدر المصنوعات", "لأن اليابانيين يسافرون للسياحة يوميًا"], answer: "لأن اليابان تستورد الخامات وتصدر المصنوعات" },
//   //   { time: 10, question: ". كيفَ كافحَ اليابانيّونَ مضايقةَ مياهِ البحرِ لمدينتِهم؟", options: ["ببناء سدود حجرية ضخمة", "بتجفيف البحر كاملاً", "بإنشاء جسور متعددة الطبقات فوق الماء"], answer: "بإنشاء جسور متعددة الطبقات فوق الماء" },
//   //   { time: 15, question: ". ما اسمُ الفندقِ الَّذي نزلَ فيهِ الكاتبُ؟ وأين يقعُ؟", options: ["فندق السلام", "فندق داييشي", "فندق الشرق الأوسط"], answer: "فندق داييشي" },
//   //   { time: 20, question: ". عدّدِ الأماكن الَّتي زارَها الكاتبُ.", options: ["5", "3", "2"], answer: "5" },
//   //   { time: 25, question: ". وردتْ في الفِقْرةِ الأولى كلمةٌ بمعنى (أخافني). استخرجها.", options: ["أدهشني", "راعني", "سرّني"], answer: "راعني" },
//   //   { time: 30, question: ". . (مِنَ المطارِ إلى قلبِ المدينةِ يُشاهدُ المرءُ مضايقةَ البحرِ لها) مضايقة البحرِ في العبارةِ السابقةِ تدلُّ علی أَنَّ البحرَ يُشكِّلُ:مساحةً ............................ مِنَ المدينةِ", options: ["صغيرة جدًا", "ضائعة", "واسعة من المدينة"], answer: "واسعة من المدينة" },
//   //   { time: 35, question: ". استبدلْ بالكلماتِ الَّتي تحتَها خطٌّ كلماتٍ تَحملُ المعنى نفسهُ:- بل هِيَ أكبرُ مُدُنِ العالمِ (قاطبةً) ", options: ["جميعًا", "بعيدًا", "وحدها"], answer: "جميعًا" },
//   //   { time: 40, question: "استبدلْ بالكلماتِ الَّتي تحتَها خطٌّ كلماتٍ تَحملُ المعنى نفسهُ:- ومِنَ الواقعِ الذي (لمستُه) ", options: ["نسيته", "شاهدته", "كتبته"], answer: "شاهدته" },
//   //   { time: 45, question: ". ابحثْ في المعجمِ عنْ معنی  الراجِلُ .", options: ["من يسير على قدميه", "من يقود الدراجة", "من يقف طوال الوقت"], answer: "من يسير على قدميه" },
//   //   { time: 45, question: ". ابحثْ في المعجمِ عنْ معنی يخدش.", options: ["يلعب", "يجرح", "يسير"], answer: "يجرح" },
//   //   { time: 50, question: ". (اليابانُ بلدُ عَمَلٍ) استخرج مِنَ النَّص ما يؤكد ذلكَ.", options: ["قلة الموظفين في الشوارع", "كثرة المقاهي الفارغة", "الموظفون ينجزون العمل بسرعة ومهارة"], answer: "الموظفون ينجزون العمل بسرعة ومهارة" },
//   //   { time: 60, question: ". دُهِش الكاتبُ منَ الغرفةِ الَّتي نزلَ بها في الفندقِ، ثمَّ زالتْ دهشتُهُ. وضحْ سببَ ذلكَ.", options: ["لأنها تحوّلت لاحقًا إلى جناح فاخر", "لأنها احتوت كل ما يحتاجه النزيل رغم صغرها", "لأنها كانت بلا أثاث"], answer: "لأنها احتوت كل ما يحتاجه النزيل رغم صغرها" },
//   //   { time: 65, question: ".  تُعدُّ غرفةُ الفندقِ نموذجًا يَصفُ قدرةَ اليابانيينَ علی اختصارِ الأشياءِ، والانتفاعِ بالمساحاتِ الضيِّقةِ.", options: ["السيارات الصغيرة المستكملة الأدوات", "نحت تماثيل ضخمة", "بناء صحارى واسعة"], answer: "السيارات الصغيرة المستكملة الأدوات" },
//   //   { time: 70, question: ".  النص السابقُ ينتمي إلى أدب:", options: ["المسرحية", "القصة", "الرحلات"], answer: "الرحلات" },
//   //   { time: 75, question: ". أي الأسلوبينِ شاعَ في النّص؟ وَلِماذا؟", options: ["الأسلوب الحواري", "الأسلوب الساخر", "الأسلوب الوصفي"], answer: "الأسلوب الوصفي" },
//   // ];

//   // لم نعد نحتاج handleProgress أو useEffect للبحث حسب الوقت!
//   useEffect(() => {
//     setIsPlaying(false);

//   }, [])
//   const startPlaying = () => {
//     setIsPlaying(true);
//   };

//   // 🚀 يتم استدعاؤها عند انتهاء الفيديو لبدء الاختبار
//   const handleVideoEnd = () => {
//     setIsPlaying(false);
//     setVideoEnded(true);
//     setCorrectCount(0)
//     setWrongCount(0)
//     if (questions.length > 0) {
//       // ابدأ بالسؤال الأول (الفهرس 0)
//       setCurrentQuestion(questions[0]);
//       setCurrentQuestionIndex(0);
//     }

//   };

//   // 🚀 منطق الإجابة والانتقال إلى السؤال التالي
//   // const handleAnswer = (option) => {
    
//   //   if (option === currentQuestion.answer) {
//   //     alert("✅ إجابة صحيحة!");

//   //     const nextIndex = currentQuestionIndex + 1;

//   //     if (nextIndex < questions.length) {
//   //       // الانتقال إلى السؤال التالي
//   //       setCurrentQuestion(questions[nextIndex]);
//   //       setCurrentQuestionIndex(nextIndex);
//   //     } else {
//   //       // انتهت جميع الأسئلة
//   //       alert("🥳 تهانينا! لقد أكملت جميع أسئلة المراجعة بنجاح.");
//   //       setCurrentQuestion(null);
//   //     }
//   //   } else {
//   //     alert("❌ إجابة خاطئة. يرجى المحاولة مرة أخرى.");
//   //     // يظل السؤال الحالي معروضًا حتى يجيب بشكل صحيح
//   //   }
//   // };

// // const handleAnswer = (option) => {
// //   const isCorrect = option === currentQuestion.answer;

// //   // تسجيل الإجابة
// //   setCorrectCount((prev) => prev + (isCorrect ? 1 : 0));
// //   setWrongCount((prev) => prev + (!isCorrect ? 1 : 0));

// //   // الانتقال للسؤال التالي
// //   const nextIndex = currentQuestionIndex + 1;

// //   if (nextIndex < questions.length) {
// //     // ننتقل للسؤال التالي
// //     setCurrentQuestion(questions[nextIndex]);
// //     setCurrentQuestionIndex(nextIndex);
// //   } else {
// //     // لا يوجد أسئلة أخرى — نعرض النتائج
// //     setCurrentQuestion(null);

// //     setTimeout(() => {
// //       alert(`📊 النتيجة النهائية:
// // ✔ الصحيحة: ${correctCount + (isCorrect ? 1 : 0)}
// // ❌ الخاطئة: ${wrongCount + (!isCorrect ? 1 : 0)}`);
// //     }, 200);
// //   }
// // };
// // const handleAnswer = (option) => {
// //   console.log(currentQuestion.answer);
  
// //   const isCorrect = option === currentQuestion.answer;

// //   // استخدم قيم محلية لحساب النتائج
// //   let newCorrect = correctCount;
// //   let newWrong = wrongCount;

// //   if (isCorrect) {
// //     newCorrect += 1;
// //   } else {
// //     newWrong += 1;
// //   }

// //   // تحديث state
// //   setCorrectCount(newCorrect);
// //   setWrongCount(newWrong);

// //   // الانتقال للسؤال التالي
// //   const nextIndex = currentQuestionIndex + 1;

// //   if (nextIndex < questions.length) {
// //     setCurrentQuestion(questions[nextIndex]);
// //     setCurrentQuestionIndex(nextIndex);
// //   } else {
// //     // لا يوجد أسئلة أخرى — نعرض النتائج
// //     setCurrentQuestion(null);

// //     // استخدم القيم المحلية للحساب النهائي
// //     setTimeout(() => {
// //       alert(`📊 النتيجة النهائية:
// // ✔ الصحيحة: ${newCorrect}
// // ❌ الخاطئة: ${newWrong}`);
// //     }, 100);
// //   }
// // };

// // const handleAnswer = (option) => {
// //     // 1. تحديد ما إذا كانت الإجابة صحيحة
// //     const currentdata=currentQuestion.options.find((item)=>item?.is_correct==1)
// //     const isCorrect = option === currentdata.option;

// //     // 2. استخدم قيم محلية لحساب النتائج
// //     let newCorrect = correctCount;
// //     let newWrong = wrongCount;

// //     // 3. عرض التنبيه بناءً على الإجابة وتحديث العدّادات المحلية
// //     if (isCorrect) {
// //         newCorrect += 1;
// //         alert("✅ إجابة صحيحة!"); // تنبيه للإجابة الصحيحة
// //     } else {
// //         newWrong += 1;
// //             const currentdata=currentQuestion.options.find((item)=>item?.is_correct==1)

// //         // تنبيه للإجابة الخاطئة مع عرض الإجابة الصحيحة
// //         alert(`❌ إجابة خاطئة. الإجابة الصحيحة هي: ${currentdata.option}`); 
// //     }

// //     // 4. تحديث state (يجب أن يتم بعد استخدام القيم المحلية للحساب النهائي لـ alert النتائج)
// //     setCorrectCount(newCorrect);
// //     setWrongCount(newWrong);

// //     // 5. الانتقال للسؤال التالي
// //     const nextIndex = currentQuestionIndex + 1;

// //     if (nextIndex < questions.length) {
// //         // ننتقل للسؤال التالي
// //         setCurrentQuestion(questions[nextIndex]);
// //         setCurrentQuestionIndex(nextIndex);
// //     } else {
// //         // لا يوجد أسئلة أخرى — نعرض النتائج
// //         setCurrentQuestion(null);

// //         // 6. عرض النتيجة النهائية بعد فترة قصيرة
// //         setTimeout(() => {
// //             alert(`📊 النتيجة النهائية:
// // ✔ الصحيحة: ${newCorrect}
// // ❌ الخاطئة: ${newWrong}`);
// //         }, 100);
// //     }
// // };


// // const handleAnswer = (option) => {
// //   console.log(option);
  
// //     const currentdata = currentQuestion.options.find((item) => item.is_correct == 1);

// //     const isCorrect = option.option === currentdata.option;

// //     let newCorrect = correctCount;
// //     let newWrong = wrongCount;

// //     if (isCorrect) {
// //         newCorrect += 1;
// //         alert("✅ إجابة صحيحة!");
// //     } else {
// //         newWrong += 1;
// //         alert(`❌ إجابة خاطئة. الإجابة الصحيحة هي: ${currentdata.option}`);
// //     }

// //     setCorrectCount(newCorrect);
// //     setWrongCount(newWrong);

// //     const nextIndex = currentQuestionIndex + 1;

// //     if (nextIndex < questions.length) {
// //         setCurrentQuestion(questions[nextIndex]);
// //         setCurrentQuestionIndex(nextIndex);
// //     } else {
// //         setCurrentQuestion(null);

// //         setTimeout(() => {
// //             alert(`📊 النتيجة النهائية:
// // ✔ الصحيحة: ${newCorrect}
// // ❌ الخاطئة: ${newWrong}`);
// //         }, 100);
// //     }
// // };


// const handleAnswer = (option) => {
//   console.log("الإجابة المختارة:", option);

//   const currentdata = currentQuestion.options.find((item) => item.is_correct == 1);

//   const isCorrect = option === currentdata.option;

//   let newCorrect = correctCount;
//   let newWrong = wrongCount;

//   if (isCorrect) {
//     newCorrect += 1;
//     alert("✅ إجابة صحيحة!");
//   } else {
//     newWrong += 1;
//     alert(`❌ إجابة خاطئة. الإجابة الصحيحة هي: ${currentdata.option}`);
//   }

//   setCorrectCount(newCorrect);
//   setWrongCount(newWrong);

//   const nextIndex = currentQuestionIndex + 1;

//   if (nextIndex < questions.length) {
//     setCurrentQuestion(questions[nextIndex]);
//     setCurrentQuestionIndex(nextIndex);
//   } else {
//     setCurrentQuestion(null);
//     setTimeout(() => {
//       alert(`📊 النتيجة النهائية:
// ✔ الصحيحة: ${newCorrect}
// ❌ الخاطئة: ${newWrong}`);
//     }, 100);
//   }
// };


//   return (
//     //     <div>
//     //       <video
//     // ref={videoRef}
//     // src={'/Tokyo.mp4'}
//     // controls

//     // style={{ width: "100%",height: "50vh", backgroundColor: "black" }}
//     // playsInline
//     // webkit-playsinline="true"
//     // autoPlay={true}
//     // muted={true}
//     // onEnded={handleVideoEnd}
//     // className="video__container"
//     // // onClick={handleVideoClick}
//     // // onTouchEnd={handleVideoClick}
//     // />
//     //     </div>
//     <div style={{ position: 'relative', width: '640px', margin: '20px auto' }} className='vedio_container'>

//       <ReactPlayer
//         src={videoPath}
//         // src={'/test5.mp4'}
//         ref={playerRef}
//         controls
//         playing={isPlaying}
//         muted={false}
//         width="100%"
//         autoPlay={false}
//         height="90vh"
//         onProgress={() => { }}
//         onEnded={handleVideoEnd}
//         config={{
//           file: {
//             attributes: {
//               playsInline: true,
//               webkitPlaysInline: true,
//               controlsList: "nofullscreen"
//             }
//           }
//         }}
//       />

//       {currentQuestion && videoEnded && (
//         <div
//           style={{ position: 'absolute', bottom: 0, left: 0,right:0, width: '100%', height: '90%', backgroundColor: 'rgba(0,0,0,0.65)', color: 'white', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', zIndex: 12, padding: '20px' }}
//           className='overlay_container'
//         >
//           <h4 style={{ textAlign: "right" }}>السؤال رقم {currentQuestionIndex + 1}: {currentQuestion.question}</h4>
//           {currentQuestion.options.map((opt, i) => (
//             <button
//               key={i}
//               onClick={async() => {
                
//                                           try {
//                                             const response = await axios.post(`${apiUrl}/courses/video/submit-answer`, {
//                                               "course_question_id": currentQuestion?.id,
//                                               "course_question_option_id": opt?.id
                
//                                             }, {
//                                               headers: {
//                                                 Authorization: `Bearer ${token}`,
//                                               },
//                                             });
//                                             // setMessage("تم تسجيل الدخول بنجاح!");
//                                     handleAnswer(opt.option)
                
                
                
//                                           } catch (error) {
                
// console.log(error);
                
                
//                                           }
//               }}
//               style={{ display: 'block', width: '80%', margin: '10px 0', backgroundColor: '#d1d1d1ff', color: 'white', border: 'none', padding: '10px 15px', borderRadius: '5px', cursor: 'pointer', fontFamily: "Noto Kufi Arabic", color: "#000" }}
//               className='btn_custom'
//             >
//               {opt.option}
//             </button>
//           ))}
//           <div style={{
//             marginTop:"12px"
//           }}> 
//             <span className='mx-2 px-1 'style={{color:"transparent",margin:"0 12px"}}>للبب</span>
//             <span className='mx-2'style={{margin:"0 5px"}}>{currentQuestionIndex}</span>
//             <span className='mx-2'style={{margin:"0 5px"}}>من</span>          
//               <span className='mx-2 px-1'style={{margin:"0 5px"}}>{questions.length}</span>

            
//                         <span className='mx-2'>أسئلة تم الإجابة عليها</span>

//             </div>
//             {/* <div className='d-flex justify-content-between'style={{
//               display:"flex",
//               justifyContent:"space-between",
//               flexDirection:"row-reverse",
//               flexWrap:"wrap"
//             }}>
//               {questions.map((item,index)=>{
//                 return(
// <div style={{
//   width: "30px",
//   height: "30px",
// }}>
//   {index+1}
//   </div>
//                 )
//               })}
//               </div> */}
//         </div>
//       )}

//     </div>
//   )
// }

// export default CustomVedio



// // // import React, { useRef, useEffect, useState } from "react";

// // // function CustomVedio({lessonData}) {
// // //   console.log(lessonData?.video,"lessonData");
  
// // //     const videoRef = useRef(null);
// // //   const [currentTime, setCurrentTime] = useState(0);
//   // const [stopAtTime, setStopAtTime] = useState(148); // توقف أول عند 2:28 = 148 ثانية
// // //   const [answered, setAnswered] = useState(false); // هل تم الإجابة الصحيحة؟
// // //     const [progress, setProgress] = useState(0);

// // //   const jumpToTime = 159;
// // //   useEffect(() => {
// // //     const interval = setInterval(() => {
// // //       if (videoRef.current) {
// // //         setCurrentTime(videoRef?.current?.currentTime);
// // //       }
// // //     }, 200);
// // //     return () => clearInterval(interval);
// // //   }, []);

// // //   const handleTimeUpdate = () => {
// // //     if (videoRef?.current?.currentTime >= stopAtTime) {
// // //       videoRef.current.pause();
// // //     }
// // //   };


// //   function goFullscreen() {
// //   const container = document.getElementById("videoContainer");
// //   if (container.requestFullscreen) {
// //     container.requestFullscreen();
// //   }
// // }
// // //   // التعامل مع الضغط على أي مكان في شريط التقدم
// // //   const handleSeek = (e) => {
// // //     const video = videoRef.current;
// // //     const rect = e.currentTarget.getBoundingClientRect();
// // //     const clickX = e.clientX - rect.left; // المسافة من بداية الشريط
// // //     const newTime = (clickX / rect.width) * video.duration;
// // //     video.currentTime = newTime;
// // //     setProgress((newTime / video.duration) * 100); // تحديث الشريط مباشرة
// // //   };
// // //   useEffect(() => {
// // //     const video = videoRef.current;
// // //     if (!video) return;

// // //     const handleTimeUpdate = () => {
// // //       setProgress((video.currentTime / video.duration) * 100);
// // //     };

// // //     video.addEventListener("timeupdate", handleTimeUpdate);
// // //     return () => {
// // //       video.removeEventListener("timeupdate", handleTimeUpdate);
// // //     };
// // //   }, []);


// // //   return (
// // // <div
// // //   id="videoContainer"
// // //   style={{ position: "relative", width: "100%" }}
// // // >
// // //   {/* <button onClick={goFullscreen}>Full Screen</button> */}

// // //   <video
// // //     ref={videoRef}
// // //     src={lessonData.video}
// // //     autoPlay
// // //       // controlsList="nofullscreen"
// // //   playsInline
// // //   webkit-playsinline="true"

// // //     // controls
// // //     onTimeUpdate={handleTimeUpdate}
// // //     width="100%"
// // //   />

// // //       <div
// // //         onClick={handleSeek}
// // //         style={{
// // //           marginTop: "10px",
// // //           width: "100%",
// // //           height: "10px",
// // //           backgroundColor: "#ccc",
// // //           borderRadius: "5px",
// // //           cursor: "pointer",
// // //           position: "absolute",
// // //           bottom:0
// // //         }}
// // //       >
// // //         <div
// // //           style={{
// // //             width: `${progress}%`,
// // //             height: "100%",
// // //             backgroundColor: "#FF7622",
// // //             borderRadius: "5px",
// // //             position: "absolute",
// // //             top: 0,
// // //             left: 0,
// // //           }}
// // //         />
// // //       </div>

// // // </div>


// // //       )
// // // }

// // // export default CustomVedio

// // import React, { useRef, useState, useEffect } from "react";

// // function CustomVedio({ lessonData }) {
// //   const videoRef = useRef(null);
// //   const [isPlaying, setIsPlaying] = useState(true);
// //   const [progress, setProgress] = useState(0);

// //   useEffect(() => {
// //     const video = videoRef.current;
// //     if (!video) return;

// //     const handleTimeUpdate = () => {
// //       setProgress((video.currentTime / video.duration) * 100);
// //     };

// //     const handleEnded = () => {
// //       setProgress(100);
// //       setIsPlaying(false);
// //     };

// //     video.addEventListener("timeupdate", handleTimeUpdate);
// //     video.addEventListener("ended", handleEnded);

// //     return () => {
// //       video.removeEventListener("timeupdate", handleTimeUpdate);
// //       video.removeEventListener("ended", handleEnded);
// //     };
// //   }, []);

// //   const togglePlay = () => {
// //     const video = videoRef.current;
// //     if (!video) return;

// //     if (isPlaying) {
// //       video.pause();
// //       setIsPlaying(false);
// //     } else {
// //       video.play();
// //       setIsPlaying(true);
// //     }
// //   };

// //   // دالة لحساب الوقت من النقرة أو اللمس
// //   const handleSeek = (e) => {
// //     const video = videoRef.current;
// //     if (!video) return;

// //     let clientX;

// //     // إذا كان touch event
// //     if (e.touches && e.touches.length > 0) {
// //       clientX = e.touches[0].clientX;
// //     } else {
// //       clientX = e.clientX;
// //     }

// //     const rect = e.currentTarget.getBoundingClientRect();
// //     const clickX = rect.right - clientX; // للـ RTL (من اليمين)
// //     const newTime = (clickX / rect.width) * video.duration;

// //     video.currentTime = newTime;
// //     setProgress((newTime / video.duration) * 100);
// //   };

// //   return (
// //     <div style={{ width: "640px", margin: "20px auto", position: "relative" }}>
// //       <video
// //         ref={videoRef}
// //         src={lessonData.video}
// //         style={{ width: "100%", height: "50vh", backgroundColor: "black" }}
// //         playsInline
// //         webkit-playsinline="true"
// //         autoPlay
// //         controls
// //       />



// //       {/* شريط التقدم RTL */}
// //       <div
// //         onClick={handleSeek}
// //         onTouchStart={handleSeek}
// //         style={{
// //           position: "absolute",
// //           bottom: "10px",
// //           right: "5%",
// //           width: "90%",
// //           height: "8px",
// //           backgroundColor: "#ccc",
// //           borderRadius: "4px",
// //           cursor: "pointer",
// //           zIndex: 10,
// //         }}
// //       >
// //         <div
// //           style={{
// //             width: `${progress}%`,
// //             height: "100%",
// //             backgroundColor: "#FF7622",
// //             borderRadius: "4px",
// //             position: "absolute",
// //             top: 0,
// //             right: 0,
// //           }}
// //         />
// //       </div>
// //     </div>
// //   );
// // }

// // export default CustomVedio




// // import React, { useRef, useState, useEffect } from "react";

// // function CustomVedio({ lessonData }) {
// //   const videoRef = useRef(null);
// //   const [isPlaying, setIsPlaying] = useState(true);
// //   const [progress, setProgress] = useState(0);

// //   useEffect(() => {
// //     const video = videoRef.current;
// //     if (!video) return;

// //     const handleTimeUpdate = () => {
// //       setProgress((video.currentTime / video.duration) * 100);
// //     };

// //     const handleEnded = () => {
// //       setProgress(100);
// //       setIsPlaying(false);
// //     };

// //     video.addEventListener("timeupdate", handleTimeUpdate);
// //     video.addEventListener("ended", handleEnded);

// //     return () => {
// //       video.removeEventListener("timeupdate", handleTimeUpdate);
// //       video.removeEventListener("ended", handleEnded);
// //     };
// //   }, []);

// //   const togglePlay = () => {
// //     const video = videoRef.current;
// //     if (!video) return;

// //     if (isPlaying) {
// //       video.pause();
// //       setIsPlaying(false);
// //     } else {
// //       video.play();
// //       setIsPlaying(true);
// //     }
// //   };

// //   // دالة لحساب الوقت من النقرة أو اللمس
// //   const handleSeek = (e) => {
// //     const video = videoRef.current;
// //     if (!video) return;

// //     let clientX;

// //     // إذا كان touch event
// //     if (e.touches && e.touches.length > 0) {
// //       clientX = e.touches[0].clientX;
// //     } else {
// //       clientX = e.clientX;
// //     }

// //     const rect = e.currentTarget.getBoundingClientRect();
// //     const clickX = rect.right - clientX; // للـ RTL (من اليمين)
// //     const newTime = (clickX / rect.width) * video.duration;

// //     video.currentTime = newTime;
// //     setProgress((newTime / video.duration) * 100);
// //   };

// //   return (
// //     <div style={{ width: "640px", margin: "20px auto", position: "relative" }}>
// //       <video
// //         ref={videoRef}
// //         src={lessonData.video}
// //         style={{ width: "100%", height: "50vh", backgroundColor: "black" }}
// //         playsInline
// //         webkit-playsinline="true"
// //         autoPlay
// //         controls
// //       />



// //       {/* شريط التقدم RTL */}
// //       <div
// //         onClick={handleSeek}
// //         onTouchStart={handleSeek}
// //         style={{
// //           position: "absolute",
// //           bottom: "10px",
// //           right: "5%",
// //           width: "90%",
// //           height: "8px",
// //           backgroundColor: "#ccc",
// //           borderRadius: "4px",
// //           cursor: "pointer",
// //           zIndex: 10,
// //         }}
// //       >
// //         <div
// //           style={{
// //             width: `${progress}%`,
// //             height: "100%",
// //             backgroundColor: "#FF7622",
// //             borderRadius: "4px",
// //             position: "absolute",
// //             top: 0,
// //             right: 0,
// //           }}
// //         />
// //       </div>
// //     </div>
// //   );
// // }

// // export default CustomVedio


// import React, { useRef, useState, useEffect } from "react";
// import "./CustomVedio.css"
// function CustomVedio({ lessonData }) {
// const videoRef = useRef(null);
// const [isPlaying, setIsPlaying] = useState(true);
// const [progress, setProgress] = useState(0);
// const [answered, setAnswered] = useState(0);
//   const [stopAtTime, setStopAtTime] = useState(lessonData.stopAtTime); // توقف أول عند 2:28 = 148 ثانية
//     const [videoEnded, setVideoEnded] = useState(false);
//     const [currentQuestion, setCurrentQuestion] = useState(null);
//     const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0); // 🚀 تتبع الفهرس

// // const jumpToTime = 159;
// const jumpToTime = lessonData.jumpToTime;
// useEffect(() => {
// const video = videoRef.current;
// if (!video) return;

// const handleTimeUpdate = () => {
//   setProgress((video.currentTime / video.duration) * 100);

//   // توقف الفيديو عند الثانية المحددة فقط أثناء التشغيل الطبيعي
//   // if (video.currentTime >= stopAtTime && isPlaying) {
//   //   video.pause();
//   //   setIsPlaying(false);
//   // }
// };

// const handleEnded = () => {
//   setProgress(100);
//   setIsPlaying(false);
// };

// video.addEventListener("timeupdate", handleTimeUpdate);
// video.addEventListener("ended", handleEnded);

// return () => {
//   video.removeEventListener("timeupdate", handleTimeUpdate);
//   video.removeEventListener("ended", handleEnded);
// };

// }, [isPlaying]);

// const togglePlay = () => {
// const video = videoRef.current;
// if (!video) return;

// // إذا الفيديو تجاوز نقطة التوقف، أعد ضبطه على stopAtTime قبل التشغيل
// if (video.currentTime >= stopAtTime) {
//   video.currentTime = stopAtTime;
// }

// if (isPlaying) {
//   video.pause();
//   setIsPlaying(false);
// } else {
//   video.play();
//   setIsPlaying(true);
// }

// };

// const handleSeek = (e) => {
// const video = videoRef.current;
// if (!video) return;

// let clientX;
// if (e.touches && e.touches.length > 0) {
//   clientX = e.touches[0].clientX;
// } else {
//   clientX = e.clientX;
// }

// const rect = e.currentTarget.getBoundingClientRect();
// const clickX = rect.right - clientX; // RTL
// const newTime = (clickX / rect.width) * video.duration;

// // ضع الفيديو على الوقت الجديد مباشرة
// video.currentTime = newTime;
// setProgress((newTime / video.duration) * 100);

// };
// const handleVideoClick = (event) => {
//     // 🛑 الأهم: منع سلوك المتصفح الافتراضي (مثل تشغيل/إيقاف الفيديو)
//     event.preventDefault(); 
//     event.stopPropagation(); 
    
//     const video = videoRef.current;
//     const rect = video.getBoundingClientRect();

//     let clientX, clientY;

//     // 1. استخراج الإحداثيات بناءً على نوع الحدث (Mouse vs Touch)
//     if (event.touches && event.touches.length > 0) {
//         // حدث لمس (لـ onTouchStart)
//         clientX = event.touches[0].clientX;
//         clientY = event.touches[0].clientY;
//     } else if (event.changedTouches && event.changedTouches.length > 0) {
//         // حدث لمس بعد التغيير (لـ onTouchEnd)
//         clientX = event.changedTouches[0].clientX;
//         clientY = event.changedTouches[0].clientY;
//     } else {
//         // حدث نقر (لـ onClick)
//         clientX = event.clientX;
//         clientY = event.clientY;
//     }

//     // 2. حساب الإحداثيات النسبية (X و Y)
//     const x = clientX - rect.left;
//     const y = clientY - rect.top;

//     const xPercent = (x / rect.width) * 100;
//     const yPercent = (y / rect.height) * 100;
    
//     // ... باقي منطق التحقق من الإجابة (بدون تغيير) ...

//     // التحقق من الإجابة الأولى فقط إذا لم تُجب بعد
//     if (video.currentTime >= stopAtTime && !answered) {
//           if (video.currentTime >= stopAtTime) {

//         if (xPercent <= lessonData?.xPercent && yPercent >= lessonData?.yPercent1 && yPercent <= lessonData?.yPercent2) {
//             alert("✅ إجابة صحيحة!");
//             video.currentTime = jumpToTime;
//             video.play();
//             setAnswered(true);
//             setStopAtTime(153);
//         } else {
//             alert("❌ إجابة خاطئة. يرجى المحاولة مرة أخرى.");
//         }
//       }
//         return;
//     }

//     // التحقق من الإجابة الثانية بعد الثانية المحددة
//     if (video.currentTime >= jumpToTime) {
//         if (xPercent <= lessonData?.xPercent2 && yPercent >= lessonData?.yPercent3 && yPercent <= lessonData?.yPercent4) {
//             alert("✅ إجابة صحيحة!");
//         } else {
//             alert("❌ إجابة خاطئة. يرجى المحاولة مرة أخرى.");
//         }
//         return;
//     }
// };

//     const handleVideoEnd = () => {
//         setIsPlaying(false);
//         setVideoEnded(true);
//         if (lessonData.questions.length > 0) {
//             // ابدأ بالسؤال الأول (الفهرس 0)
//             setCurrentQuestion(lessonData.questions[0]); 
//             setCurrentQuestionIndex(0);
//         }
//     };

//     // 🚀 منطق الإجابة والانتقال إلى السؤال التالي
//     const handleAnswer = (option) => {
//         if (option === currentQuestion.answer) {
//             alert("✅ إجابة صحيحة!");
            
//             const nextIndex = currentQuestionIndex + 1;
            
//             if (nextIndex < lessonData.questions.length) {
//                 // الانتقال إلى السؤال التالي
//                 setCurrentQuestion(lessonData.questions[nextIndex]);
//                 setCurrentQuestionIndex(nextIndex);
//             } else {
//                 // انتهت جميع الأسئلة
//                 alert("🥳 تهانينا! لقد أكملت جميع أسئلة المراجعة بنجاح.");
//                 setCurrentQuestion(null);
//             }
//         } else {
//             alert("❌ إجابة خاطئة. يرجى المحاولة مرة أخرى.");
//             // يظل السؤال الحالي معروضًا حتى يجيب بشكل صحيح
//         }
//     };
// return (
// <div style={{   position: "relative" }}>
// <video
// ref={videoRef}
// src={lessonData.video}
// style={{ width: "100%",height: "50vh", backgroundColor: "black" }}
// playsInline
// webkit-playsinline="true"
// autoPlay
// onEnded={handleVideoEnd}
// className="video__container"
// // onClick={handleVideoClick}
// // onTouchEnd={handleVideoClick}
// />
//           {currentQuestion && videoEnded && (
//                 <div
//                     style={{ position: 'absolute', left: "25%", bottom:"10%",width: '50%', height: '84%', backgroundColor: 'rgba(236,236,236,1)', color: 'white', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', zIndex: 12, padding: '20px',borderRadius:"22px" ,boxShadow:"0px 4px 12px rgba(0,0,0,0.2)"}}
//                     className='question_container'
//                 >
//                     <h4 style={{color:"rgba(118,125,129,1)",textAlign:"right",fontSize:"15px"}}>السؤال رقم {currentQuestionIndex + 1}: {currentQuestion.question}</h4>
//                     {currentQuestion.options.map((opt, i) => (
//                         <button
//                             key={i}
//                             onClick={() => handleAnswer(opt)}
//                             style={{ display: 'block', width: '80%',fontSize:"12px", margin: '10px 0', color: 'black', border: 'none', padding: '10px 15px', borderRadius: '5px', cursor: 'pointer' }}
//                             className='option_container'
//                         >
//                         {opt}
//                         </button>
//                     ))}
//                 </div>
//             )}
//   <div
//     onClick={handleSeek}
//     onTouchStart={handleSeek}
//     style={{
//       position: "absolute",
//       bottom: "10px",
//       right: "5%",
//       width: "90%",
//       height: "8px",
//       backgroundColor: "#ccc",
//       borderRadius: "4px",
//       cursor: "pointer",
//       zIndex: 10,
//     }}
//   >
//     <div
//       style={{
//         width: `${progress}%`,
//         height: "100%",
//         backgroundColor: "#FF7622",
//         borderRadius: "4px",
//         position: "absolute",
//         top: 0,
//         right: 0,
//       }}
//     />
//   </div>
// </div>

// );
// }

// export default CustomVedio;

import React, { useEffect, useRef, useState } from 'react'
import ReactPlayer from 'react-player';

function CustomVedio({questions,videoPath}) {
  const videoRef = useRef(null);
const [correctCount, setCorrectCount] = useState(0);
const [wrongCount, setWrongCount] = useState(0);

  const playerRef = useRef(null);
  const [videoEnded, setVideoEnded] = useState(false);
  const [currentQuestion, setCurrentQuestion] = useState(null);
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0); // 🚀 تتبع الفهرس
  const [answered, setAnswered] = useState(false);
  const [isPlaying, setIsPlaying] = useState(false);

  // const questions = [
  //   { time: 5, question: ".اذكرْ سببَ كَثرةِ البواخرِ في مياهِ طوكيو حَسبَ رأي الكاتبِ", options: ["لأن اليابان تمتلك أكبر أسطول صيد في العالم", "لأن اليابان تستورد الخامات وتصدر المصنوعات", "لأن اليابانيين يسافرون للسياحة يوميًا"], answer: "لأن اليابان تستورد الخامات وتصدر المصنوعات" },
  //   { time: 10, question: ". كيفَ كافحَ اليابانيّونَ مضايقةَ مياهِ البحرِ لمدينتِهم؟", options: ["ببناء سدود حجرية ضخمة", "بتجفيف البحر كاملاً", "بإنشاء جسور متعددة الطبقات فوق الماء"], answer: "بإنشاء جسور متعددة الطبقات فوق الماء" },
  //   { time: 15, question: ". ما اسمُ الفندقِ الَّذي نزلَ فيهِ الكاتبُ؟ وأين يقعُ؟", options: ["فندق السلام", "فندق داييشي", "فندق الشرق الأوسط"], answer: "فندق داييشي" },
  //   { time: 20, question: ". عدّدِ الأماكن الَّتي زارَها الكاتبُ.", options: ["5", "3", "2"], answer: "5" },
  //   { time: 25, question: ". وردتْ في الفِقْرةِ الأولى كلمةٌ بمعنى (أخافني). استخرجها.", options: ["أدهشني", "راعني", "سرّني"], answer: "راعني" },
  //   { time: 30, question: ". . (مِنَ المطارِ إلى قلبِ المدينةِ يُشاهدُ المرءُ مضايقةَ البحرِ لها) مضايقة البحرِ في العبارةِ السابقةِ تدلُّ علی أَنَّ البحرَ يُشكِّلُ:مساحةً ............................ مِنَ المدينةِ", options: ["صغيرة جدًا", "ضائعة", "واسعة من المدينة"], answer: "واسعة من المدينة" },
  //   { time: 35, question: ". استبدلْ بالكلماتِ الَّتي تحتَها خطٌّ كلماتٍ تَحملُ المعنى نفسهُ:- بل هِيَ أكبرُ مُدُنِ العالمِ (قاطبةً) ", options: ["جميعًا", "بعيدًا", "وحدها"], answer: "جميعًا" },
  //   { time: 40, question: "استبدلْ بالكلماتِ الَّتي تحتَها خطٌّ كلماتٍ تَحملُ المعنى نفسهُ:- ومِنَ الواقعِ الذي (لمستُه) ", options: ["نسيته", "شاهدته", "كتبته"], answer: "شاهدته" },
  //   { time: 45, question: ". ابحثْ في المعجمِ عنْ معنی  الراجِلُ .", options: ["من يسير على قدميه", "من يقود الدراجة", "من يقف طوال الوقت"], answer: "من يسير على قدميه" },
  //   { time: 45, question: ". ابحثْ في المعجمِ عنْ معنی يخدش.", options: ["يلعب", "يجرح", "يسير"], answer: "يجرح" },
  //   { time: 50, question: ". (اليابانُ بلدُ عَمَلٍ) استخرج مِنَ النَّص ما يؤكد ذلكَ.", options: ["قلة الموظفين في الشوارع", "كثرة المقاهي الفارغة", "الموظفون ينجزون العمل بسرعة ومهارة"], answer: "الموظفون ينجزون العمل بسرعة ومهارة" },
  //   { time: 60, question: ". دُهِش الكاتبُ منَ الغرفةِ الَّتي نزلَ بها في الفندقِ، ثمَّ زالتْ دهشتُهُ. وضحْ سببَ ذلكَ.", options: ["لأنها تحوّلت لاحقًا إلى جناح فاخر", "لأنها احتوت كل ما يحتاجه النزيل رغم صغرها", "لأنها كانت بلا أثاث"], answer: "لأنها احتوت كل ما يحتاجه النزيل رغم صغرها" },
  //   { time: 65, question: ".  تُعدُّ غرفةُ الفندقِ نموذجًا يَصفُ قدرةَ اليابانيينَ علی اختصارِ الأشياءِ، والانتفاعِ بالمساحاتِ الضيِّقةِ.", options: ["السيارات الصغيرة المستكملة الأدوات", "نحت تماثيل ضخمة", "بناء صحارى واسعة"], answer: "السيارات الصغيرة المستكملة الأدوات" },
  //   { time: 70, question: ".  النص السابقُ ينتمي إلى أدب:", options: ["المسرحية", "القصة", "الرحلات"], answer: "الرحلات" },
  //   { time: 75, question: ". أي الأسلوبينِ شاعَ في النّص؟ وَلِماذا؟", options: ["الأسلوب الحواري", "الأسلوب الساخر", "الأسلوب الوصفي"], answer: "الأسلوب الوصفي" },
  // ];

  // لم نعد نحتاج handleProgress أو useEffect للبحث حسب الوقت!
  useEffect(() => {
    setIsPlaying(false);

  }, [])
  const startPlaying = () => {
    setIsPlaying(true);
  };

  // 🚀 يتم استدعاؤها عند انتهاء الفيديو لبدء الاختبار
  const handleVideoEnd = () => {
    setIsPlaying(false);
    setVideoEnded(true);
    setCorrectCount(0)
    setWrongCount(0)
    if (questions.length > 0) {
      // ابدأ بالسؤال الأول (الفهرس 0)
      setCurrentQuestion(questions[0]);
      setCurrentQuestionIndex(0);
    }

  };

  // 🚀 منطق الإجابة والانتقال إلى السؤال التالي
  // const handleAnswer = (option) => {
    
  //   if (option === currentQuestion.answer) {
  //     alert("✅ إجابة صحيحة!");

  //     const nextIndex = currentQuestionIndex + 1;

  //     if (nextIndex < questions.length) {
  //       // الانتقال إلى السؤال التالي
  //       setCurrentQuestion(questions[nextIndex]);
  //       setCurrentQuestionIndex(nextIndex);
  //     } else {
  //       // انتهت جميع الأسئلة
  //       alert("🥳 تهانينا! لقد أكملت جميع أسئلة المراجعة بنجاح.");
  //       setCurrentQuestion(null);
  //     }
  //   } else {
  //     alert("❌ إجابة خاطئة. يرجى المحاولة مرة أخرى.");
  //     // يظل السؤال الحالي معروضًا حتى يجيب بشكل صحيح
  //   }
  // };

// const handleAnswer = (option) => {
//   const isCorrect = option === currentQuestion.answer;

//   // تسجيل الإجابة
//   setCorrectCount((prev) => prev + (isCorrect ? 1 : 0));
//   setWrongCount((prev) => prev + (!isCorrect ? 1 : 0));

//   // الانتقال للسؤال التالي
//   const nextIndex = currentQuestionIndex + 1;

//   if (nextIndex < questions.length) {
//     // ننتقل للسؤال التالي
//     setCurrentQuestion(questions[nextIndex]);
//     setCurrentQuestionIndex(nextIndex);
//   } else {
//     // لا يوجد أسئلة أخرى — نعرض النتائج
//     setCurrentQuestion(null);

//     setTimeout(() => {
//       alert(`📊 النتيجة النهائية:
// ✔ الصحيحة: ${correctCount + (isCorrect ? 1 : 0)}
// ❌ الخاطئة: ${wrongCount + (!isCorrect ? 1 : 0)}`);
//     }, 200);
//   }
// };
// const handleAnswer = (option) => {
//   console.log(currentQuestion.answer);
  
//   const isCorrect = option === currentQuestion.answer;

//   // استخدم قيم محلية لحساب النتائج
//   let newCorrect = correctCount;
//   let newWrong = wrongCount;

//   if (isCorrect) {
//     newCorrect += 1;
//   } else {
//     newWrong += 1;
//   }

//   // تحديث state
//   setCorrectCount(newCorrect);
//   setWrongCount(newWrong);

//   // الانتقال للسؤال التالي
//   const nextIndex = currentQuestionIndex + 1;

//   if (nextIndex < questions.length) {
//     setCurrentQuestion(questions[nextIndex]);
//     setCurrentQuestionIndex(nextIndex);
//   } else {
//     // لا يوجد أسئلة أخرى — نعرض النتائج
//     setCurrentQuestion(null);

//     // استخدم القيم المحلية للحساب النهائي
//     setTimeout(() => {
//       alert(`📊 النتيجة النهائية:
// ✔ الصحيحة: ${newCorrect}
// ❌ الخاطئة: ${newWrong}`);
//     }, 100);
//   }
// };

const handleAnswer = (option) => {
    // 1. تحديد ما إذا كانت الإجابة صحيحة
    const isCorrect = option === currentQuestion.options.find((items)=>items.is_correct==1).option;
console.log(currentQuestion);

    // 2. استخدم قيم محلية لحساب النتائج
    let newCorrect = correctCount;
    let newWrong = wrongCount;

    // 3. عرض التنبيه بناءً على الإجابة وتحديث العدّادات المحلية
    if (isCorrect) {
        newCorrect += 1;
        alert("✅ إجابة صحيحة!"); // تنبيه للإجابة الصحيحة
    } else {
        newWrong += 1;
        // تنبيه للإجابة الخاطئة مع عرض الإجابة الصحيحة
        alert(`❌ إجابة خاطئة. الإجابة الصحيحة هي: ${currentQuestion.options.find((items)=>items.is_correct==1).option}`); 
    }

    // 4. تحديث state (يجب أن يتم بعد استخدام القيم المحلية للحساب النهائي لـ alert النتائج)
    setCorrectCount(newCorrect);
    setWrongCount(newWrong);

    // 5. الانتقال للسؤال التالي
    const nextIndex = currentQuestionIndex + 1;

    if (nextIndex < questions.length) {
        // ننتقل للسؤال التالي
        setCurrentQuestion(questions[nextIndex]);
        setCurrentQuestionIndex(nextIndex);
    } else {
        // لا يوجد أسئلة أخرى — نعرض النتائج
        setCurrentQuestion(null);

        // 6. عرض النتيجة النهائية بعد فترة قصيرة
        setTimeout(() => {
            alert(`📊 النتيجة النهائية:
✔ الصحيحة: ${newCorrect}
❌ الخاطئة: ${newWrong}`);
        }, 100);
    }
};

  return (
    //     <div>
    //       <video
    // ref={videoRef}
    // src={'/Tokyo.mp4'}
    // controls

    // style={{ width: "100%",height: "50vh", backgroundColor: "black" }}
    // playsInline
    // webkit-playsinline="true"
    // autoPlay={true}
    // muted={true}
    // onEnded={handleVideoEnd}
    // className="video__container"
    // // onClick={handleVideoClick}
    // // onTouchEnd={handleVideoClick}
    // />
    //     </div>
    <div style={{ position: 'relative', width: '640px', margin: '20px auto' }} className='vedio_container'>

      <ReactPlayer
        src={videoPath}
        // src={'/test5.mp4'}
        ref={playerRef}
        controls
        playing={isPlaying}
        muted={false}
        width="100%"
        autoPlay={false}
        height="90vh"
        onProgress={() => { }}
        onEnded={handleVideoEnd}
        config={{
          file: {
            attributes: {
              playsInline: true,
              webkitPlaysInline: true,
              controlsList: "nofullscreen"
            }
          }
        }}
      />

      {currentQuestion && videoEnded && (
        <div
          style={{ position: 'absolute', bottom: 0, left: 0,right:0, width: '100%', height: '90%', backgroundColor: 'rgba(0,0,0,0.65)', color: 'white', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', zIndex: 12, padding: '20px' }}
          className='overlay_container'
        >
          <h4 style={{ textAlign: "right" }}>السؤال رقم {currentQuestionIndex + 1}: {currentQuestion.question}</h4>
          {currentQuestion.options.map((opt, i) => (
            <button
              key={i}
              onClick={() => handleAnswer(opt?.option)}
              style={{ display: 'block', width: '80%', margin: '10px 0', backgroundColor: '#d1d1d1ff', color: 'white', border: 'none', padding: '10px 15px', borderRadius: '5px', cursor: 'pointer', fontFamily: "Noto Kufi Arabic", color: "#000" }}
              className='btn_custom'
            >
              {opt?.option}
            </button>
          ))}
          <div style={{
            marginTop:"12px"
          }}> 
            <span className='mx-2 px-1 'style={{color:"transparent",margin:"0 12px"}}>للبب</span>
            <span className='mx-2'style={{margin:"0 5px"}}>{currentQuestionIndex}</span>
            <span className='mx-2'style={{margin:"0 5px"}}>من</span>          
              <span className='mx-2 px-1'style={{margin:"0 5px"}}>{questions.length}</span>

            
                        <span className='mx-2'>أسئلة تم الإجابة عليها</span>

            </div>
            {/* <div className='d-flex justify-content-between'style={{
              display:"flex",
              justifyContent:"space-between",
              flexDirection:"row-reverse",
              flexWrap:"wrap"
            }}>
              {questions.map((item,index)=>{
                return(
<div style={{
  width: "30px",
  height: "30px",
}}>
  {index+1}
  </div>
                )
              })}
              </div> */}
        </div>
      )}

    </div>
  )
}

export default CustomVedio